import {AuthorizationItem} from '@/modules/authorization/model/AuthorizationItem'
import KeyValuePair from '@/modules/core/support/KeyValuePair';
import moment from 'moment'
import Permission from '@/modules/authorization/model/Permission';

/**
 * Rol de usuario
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class Role extends AuthorizationItem {
    /**
     * Lista con las rutas de los permisos asignados al rol
     *
     * @var { string[] }
     */
    public permissions: string[] = []

    /**
     * Permiso necesario para actualizar este rol
     */
    public updatePermission = ''

    /**
     * Permiso necesario para modificar las asignación de permisos de este rol
     */
    public permissionAssignmentPermission = ''

    /**
     * Permiso necesario para asignar usuarios a este rol
     */
    public userAssignmentPermission = ''

    public serialize () {
        return {
            title: this.title,
            description: this.description,
            path: this.path,
            permissions: this.permissions,
            update_permission: this.updatePermission,
            permission_assignment_permission: this.permissionAssignmentPermission,
            user_assignment_permission: this.userAssignmentPermission,
        }
    }

    /**
     * Crea una entidad Role a partir de la información obtenida desde la API
     *
     * @param data
     */
    public static deserialize (data: KeyValuePair) {
        const role = new this()
        role.id = data.id
        role.key = data.key
        role.path = data.path
        role.title = data.title
        role.description = data.description
        role.createdAt = moment(data.created_at, 'DD-MM-YYYY HH:mm:ss').toDate()
        role.updatedAt = moment(data.update_at, 'DD-MM-YYYY HH:mm:ss').toDate()
        role.permissions = data.permissions || []
        role.updatePermission = data.update_permission || ''
        role.permissionAssignmentPermission = data.permission_assignment_permission || ''
        role.userAssignmentPermission = data.user_assignment_permission || ''
        if (Array.isArray(data.children)) {
            role.children = data.children.map((p: KeyValuePair) => Role.deserialize(p))
        }

        return role
    }
}
